import axiosInstance from '../utils/axiosInstance';
import {
    Button, Dialog, DialogTitle, DialogContent, DialogActions,
    Typography, Stack, Icon,
    Alert,
    Divider
} from '@mui/material';
import { TableChart } from '@mui/icons-material';
import DownloadIcon from '@mui/icons-material/Download';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import { useState } from 'react';

const CsvButtonInventory = ({ buttonStyle = '' }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isDownloading, setIsDownloading] = useState(false);
    const [csvFile, setCsvFile] = useState(null);
    const [isUploading, setIsUploading] = useState(false);
    const [message, setMessage] = useState('');
    const handleDownload = async () => {

        try {
            setIsDownloading(true);
            const res = await axiosInstance.get('/inventory/inventory-summary-csv', { responseType: 'blob' });
            const bom = new Uint8Array([0xEF, 0xBB, 0xBF]);
            const blob = new Blob([bom, res.data], { type: 'text/csv;charset=utf-8;' });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'inventory-summary.csv');
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
        } catch (err) {
            console.error('CSVダウンロード失敗', err);

        } finally {
            setIsDownloading(false);
        }
    };

    const handleFileChange = (e) => {
        setCsvFile(e.target.files[0]);
        setMessage('');
    };

    const handleUpload = async () => {
        if (!csvFile) {
            setMessage('CSVファイルを選択してください。');
            return;
        }
        const formData = new FormData();
        formData.append('csv', csvFile);
        try {
            setIsUploading(true);
            const response = await axiosInstance.post(
                '/inventory/variant-costs/upload-csv',
                formData,
                { headers: { 'Content-Type': 'multipart/form-data' } }
            );
            setMessage(response.data.message || 'アップロード成功');
        } catch (error) {
            console.error('CSVアップロード失敗:', error);
            const errMsg =
                error.response?.data?.message ??
                error.message ??
                'アップロードに失敗しました';
            setMessage(`エラー: ${errMsg}`);
        } finally {
            setIsUploading(false);
            setCsvFile(null);
        }
    };

    return (
        <>
            <Button
                variant="related-menu"
                onClick={() => setIsModalOpen(true)}
                className={buttonStyle}
            >
                <TableChart />
                在庫CSV
            </Button>

            <Dialog
                open={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                fullWidth
                maxWidth="sm"
            >
                <DialogTitle>在庫CSV</DialogTitle>
                <DialogContent>
                    <Typography variant='h4' mt={2}>ダウンロード</Typography>
                    <Typography>
                        在庫集計CSVがダウンロードできます。
                    </Typography>
                    <Button
                        variant="contained"
                        onClick={handleDownload}
                        disabled={isDownloading}
                        startIcon={<DownloadIcon />}
                        sx={{ mt: 1 }}
                    >
                        {isDownloading ? 'ダウンロード中…' : '在庫CSVをダウンロード'}
                    </Button>
                    <Divider sx={{ pt: 2 }} />
                    <Typography variant='h4' mt={2}>アップロード</Typography>
                    <Typography mb={1}>
                        上記よりダウンロードしたCSVのaverage_unit_costカラムを変更し、原価を変更可能です。
                    </Typography>
                    <Alert severity='info'>variant_idは変更しないでください。</Alert>
                    <Stack spacing={1} direction='row' sx={{ mt: 2 }}>
                        <input
                            id="csv-upload-variant-cost"
                            type="file"
                            accept=".csv"
                            hidden
                            onChange={handleFileChange}
                        />
                        <Button
                            variant="outlined"
                            component="label"
                            htmlFor="csv-upload-variant-cost"
                            startIcon={<UploadFileIcon />}
                        >原価CSV選択
                        </Button>
                        <Button
                            onClick={handleUpload}
                            variant="contained"
                            disabled={isUploading || !csvFile}
                            startIcon={<Icon>upload</Icon>}
                        >{isUploading ? 'アップロード中…' : '原価CSVアップロード'}
                        </Button>
                    </Stack>
                    {csvFile && (
                        <Typography variant="body2">選択中:{' '}{csvFile.name}</Typography>
                    )}
                    {message && (
                        <Typography
                            variant="body2"
                            color={message.startsWith('エラー') ? 'error' : 'primary'}
                        > {message}
                        </Typography>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button
                        variant="outlined"
                        onClick={() => {
                            setIsModalOpen(false);
                            setCsvFile(null);
                            setMessage('');
                        }}
                    > 閉じる
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default CsvButtonInventory;